function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2d6b87e4\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DaySwitcher.vue")
}
var Component = require("!../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DaySwitcher.vue"),
  /* template */
  require("!!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2d6b87e4\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DaySwitcher.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d6b87e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/DaySwitcher.vue
// module id = bc65e94ac70f97f72f85
// module chunks = 6